import Image from 'next/image';
import React from 'react';
import ClientCarousel from '../home/client-carousel';
import ScheduleCall from '../common/schedule-call';

type Props = {
    path: any;
    alt: string;
    title: string;
    width: number;
    height: number;
    desc: string;
    className: string;
    color?: string;
    isRed?: boolean;
    isGreen?: boolean;
    isOrange?: boolean;
    children: any;
    bgPath?: any;
};

const TechHeroApp: React.FC<Props> = ({
    path,
    alt,
    title,
    width,
    height,
    children,
    desc,
    className,
    color,
    isRed,
    isGreen,
    isOrange,
    bgPath,
}) => {
    return (
        <section className={`hero home-hero technology-herosection ${className}`}>
            <div className="container lg:container md:mx-auto top-hero">
                <div className="lg:grid hero-row gap-6 relative z-[1] h-full">
                    <div className="w-full">
                        <div className="inline-flex flex-col gap-5 justify-center h-full lg:items-start hero-content">
                            <h1 className="mb-0 dark:text-textcolor">{children}</h1>
                            <p className="mb-0 font-semibold text-secondary dark:text-secondary">{desc}</p>
                            <ScheduleCall />
                        </div>
                    </div>
                    <div className="relative text-center lg:text-start mobile-hero">
                        <div className="hero-tech-img hero-tech-app-img">
                            {isRed ? (
                                <Image
                                    className={`pic-bg ${color}`}
                                    alt="bg pattern"
                                    width={1021}
                                    height={983}
                                    priority
                                    src={`/img/hero/${bgPath}.webp`}
                                    quality={100}
                                    sizes="(max-width: 767px) 839px, (max-width: 992px) 1032px, (min-width: 1200px) 1547px"
                                />
                            ) : isGreen ? (
                                <Image
                                    className={`pic-bg ${color}`}
                                    alt="bg pattern"
                                    width={1022}
                                    height={933}
                                    priority
                                    src={`/img/hero/${bgPath}@2x.webp`}
                                    quality={100}
                                    sizes="(max-width: 767px) 839px, (max-width: 992px) 1032px, (min-width: 1200px) 1547px"
                                />
                            ) : isOrange ? (
                                <Image
                                    className={`pic-bg ${color}`}
                                    alt="bg pattern"
                                    width={1022}
                                    height={917}
                                    priority
                                    src={`/img/hero/${bgPath}.webp`}
                                    quality={100}
                                    sizes="(max-width: 767px) 839px, (max-width: 992px) 1032px, (min-width: 1200px) 1547px"
                                />
                            ) : (
                                <Image
                                    className={`pic-bg ${color}`}
                                    alt="bg pattern"
                                    width={1032}
                                    height={1021}
                                    priority
                                    src={`/img/hero/${bgPath}.webp`}
                                    quality={100}
                                    sizes="(max-width: 767px) 839px, (max-width: 992px) 1032px, (min-width: 1200px) 1547px"
                                />
                            )}
                        </div>

                        <picture className="z-[1] hero-app-img img-fluid">
                            <source media="(max-width: 767px)" srcSet={`/img/hero/${path}.webp`} />
                            <source media="(min-width: 768px)" srcSet={`/img/hero/${path}@2x.webp`} />
                            <img
                                src={`/img/hero/${path}.webp`}
                                width={width}
                                height={height}
                                alt={alt}
                                title={title}
                                loading="lazy"
                            />
                        </picture>
                    </div>
                </div>
            </div>
            <ClientCarousel />
        </section>
    );
};

export default TechHeroApp;
